import { gql } from '@apollo/client';
import { BLOG_POST_FIELDS } from '../fragments/blog';

gql`
  ${BLOG_POST_FIELDS}
  mutation CreateBlog($input: CreateBlogInput!) {
    admin {
      createBlog(input: $input) {
      ...BlogPostFields
    }
  }  }
`;

gql`
  ${BLOG_POST_FIELDS}
  mutation UpdateBlog($id: Int!, $input: UpdateBlogInput!) {
    admin {
      updateBlog(id: $id, input: $input) {
        ...BlogPostFields
      }
    }
  }
`;

gql`
  ${BLOG_POST_FIELDS}
  mutation DeleteBlog($id: Int!) {
    admin {
      deleteBlogs(ids: [$id])
    }
  }
`;